import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import Home from "@/pages/Home";
import OldTestament from "@/pages/OldTestament";
import ChapterReader from "@/pages/ChapterReader";
import PlaceholderChapter from "@/pages/PlaceholderChapter";
import InfoPage from "@/pages/InfoPage";
import SearchPage from "@/pages/SearchPage";

function App() {
  return (
    <BrowserRouter>
      <SiteHeader />
      <main data-testid="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/old-testament" element={<OldTestament />} />
          {/* Back-compat for the original /read/matthew-1 sample URL */}
          <Route
            path="/read/matthew-1"
            element={<Navigate to="/book/matthew/chapter/1" replace />}
          />
          <Route
            path="/book/:slug/chapter/:chapter"
            element={<ChapterReader />}
          />
          <Route
            path="/book/:slug/introduction"
            element={<PlaceholderChapter />}
          />
          <Route path="/about" element={<InfoPage />} />
          <Route path="/commentators" element={<InfoPage />} />
          <Route path="/notes" element={<InfoPage />} />
          <Route path="/ebooks" element={<InfoPage />} />
          <Route path="/contact" element={<InfoPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <SiteFooter />
    </BrowserRouter>
  );
}

export default App;
